import 'bootstrap/dist/css/bootstrap.min.css'; // Only needed if you installed via npm
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home"
import Login from "./Pages/Login"



function App() {
  return (
    <BrowserRouter>
      <Routes>
      <Route index element={<Login />} />
        <Route path="home" element={<Home />}></Route>
        <Route path="login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
